import CategoriesPopupProvider from './Providers/CategoriesPopupProvider'
import CategoriesTable from './CategoriesTable'

export const CategoriesContainer = ({ shortView }: { shortView: boolean }) => (
  <CategoriesPopupProvider>
    <CategoriesTable shortView={shortView} />
  </CategoriesPopupProvider>
)
